import { useContext } from "react"

import { AppContext } from "../context/AppContext"

const useSiteTitle = (viewer = false) => {
  const appContext = useContext(AppContext)
  const { store } = appContext
  if (viewer) {
    return store.initConfig.titleViewer
  }
  return store.initConfig.title
}

export default useSiteTitle
